// extracted by mini-css-extract-plugin
export default {"container":"Ata-z","tab":"Bta-z","selected":"Cta-z"};